import React from 'react';
import { ITeamLookup } from './interfaces';

export function formatTeam(team?: ITeamLookup) {
  if (!team || !team.displayName) return '';

  return `${team.isDisabled ? 'Inaktiv - ' : ''}${team.displayName}`;
}

export function renderTeam(props: object, team?: ITeamLookup) {
  return (
    <li {...props} key={team?.id}>
      {formatTeam(team)}
    </li>
  );
}
